module.exports = __webpack_public_path__ + "img/safe.73c1cbab.png";